/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import TextField from "@mui/material/TextField";
import Button from "components/ButtonUse";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./View.css";
import shirt from "./Images/shirt.jpg";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import { MdClose } from "react-icons/md";

// import { Button } from "@mui/material";
// Data

// Dashboard components

function AddNewBmGuide() {
  const [images, setImages] = useState([
    { id: 1, src: shirt },
    { id: 2, src: shirt },
    { id: 3, src: shirt },
  ]);

  const removeImage = (id) => {
    const updatedImages = images.filter((image) => image.id !== id);
    setImages(updatedImages);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            width: "80%",
            marginLeft: "10%",
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          <body>
            <div class="wrapper">
              <div class="center-line">
                <a href="#" class="scroll-icon">
                  <i class="fas fa-caret-up"></i>
                </a>
              </div>
              <div class="row row-1">
                <section>
                  <i class="icon fas fa-home"></i>
                  <div class="details">
                    <span class="title">Status</span>
                    {/* <span>1st Jan 2021</span> */}
                  </div>
                  <p>
                    Lorem ipsum dolor sit ameters consectetur adipisicing elit. Sed qui veroes
                    praesentium maiores, sint eos vero sapiente voluptas debitis dicta dolore.
                  </p>
                  {/* <div class="bottom">
                    <a href="#">Read more</a>
                    <i>- Someone famous</i>
                  </div> */}
                </section>
              </div>
              <div class="row row-2">
                <section>
                  <i class="icon fas fa-star"></i>
                  <div class="details">
                    <span class="title">Descriptions</span>
                  </div>
                  <p>
                    Lorem ipsum dolor sit ameters consectetur adipisicing elit. Sed qui veroes
                    praesentium maiores, sint eos vero sapiente voluptas debitis dicta dolore.
                  </p>
                  {/* <div class="bottom">
                    <a href="#">Read more</a>
                    <i>- Someone famous</i>
                  </div> */}
                </section>
              </div>
              <div class="row row-1">
                <section>
                  <i class="icon fas fa-rocket"></i>
                  <div class="details">
                    <span class="title">Reason</span>
                    {/* <span>3rd Jan 2021</span> */}
                  </div>
                  <p>
                    Lorem ipsum dolor sit ameters consectetur adipisicing elit. Sed qui veroes
                    praesentium maiores, sint eos vero sapiente voluptas debitis dicta dolore.
                  </p>
                  {/* <div class="bottom">
                    <a href="#">Read more</a>
                    <i>- Someone famous</i>
                  </div> */}
                </section>
              </div>
              <div class="row row-2">
                <section>
                  <i class="icon fas fa-globe"></i>
                  <div class="details">
                    <span class="title">Images</span>
                    {/* <span>4th Jan 2021</span> */}
                  </div>
                  {images.map((image) => (
                    <div key={image.id} style={{ position: "relative", display: "inline-block" }}>
                      <img src={image.src} alt="shirt" style={{ width: "100px", height: "10vw" }} />
                      <button
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          padding: "0",
                          zIndex: "1",
                        }}
                        onClick={() => removeImage(image.id)}
                      >
                        <MdClose size={20} />
                      </button>
                    </div>
                  ))}

                  {/* <p>
                    Lorem ipsum dolor sit ameters consectetur adipisicing elit. Sed qui veroes
                    praesentium maiores, sint eos vero sapiente voluptas debitis dicta dolore.
                  </p> */}
                  {/* <div class="bottom">
                    <a href="#">Read more</a>
                    <i>- Someone famous</i>
                  </div> */}
                </section>
              </div>
            </div>
          </body>

          {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button title={"Submit"}  onClick={saveData} />
          </div> */}
        </form>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default AddNewBmGuide;
